import { render, staticRenderFns } from "./ModalFavorite.vue?vue&type=template&id=adba3b4a"
import script from "./ModalFavorite.vue?vue&type=script&lang=js"
export * from "./ModalFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports